module.exports = __webpack_public_path__ + "img/bubbles.7d67d6a4.svg";